import React from 'react'

export const CRM_Ref_Bancaria = () => {
  return (
    <div>CRM_Ref_Bancaria</div>
  )
}
